export const totalEntradas = (reportes) => {
  let total = 0;
  let cantidad = 0;
  let concurrencia = 0;
  let ausentes = 0;
  let descuentos = 0;

  reportes.data.map((re) => {
    // Excluir entradas con status INVITADO de las estadísticas
    if (re.status === 'INVITADO') {
      return;
    }

    let precio = parseFloat(re.cantidad * re.unidad);
    if(re.descuento > 0){
      descuentos = (precio/100*re.descuento) + descuentos;
      precio = precio - (precio/100*re.descuento)
    }

    total = precio + total;

    let reporteCantidad = parseInt(re.cantidad);
    if(re.multiplicador){
      reporteCantidad = reporteCantidad * re.multiplicador;
    }

    cantidad = reporteCantidad + cantidad;

    if (re.reporte_codigo.length > 0) {
      re.reporte_codigo.map((rc) => {
        if (rc.ingreso == "ESPERA") {
          ausentes += 1;
        }
        if (rc.ingreso == "CONCURRIO") {
          concurrencia += 1;
        }
      });
    } else {
      if (re.registro_cliente == "CONCURRIO") {
        concurrencia += 1;
      }

      if (re.registro_cliente == "ESPERA") {
        ausentes += 1;
      }
    }
  });

  return {
    total,
    cantidad,
    concurrencia,
    ausentes,
    descuentos
  };
};

export const tipoEntrada = (reportes) => {
  let tipoEntrada = [
    {label: 'TODOS', value: 'TODOS'}
  ];


  reportes.map((re) => {
   console.log(re);
    if (tipoEntrada.filter((te) => te.value == re.entrada?.id).length > 0) {
    } else {
      tipoEntrada.push(
       {label: re.entrada?.nombre, value: re.entrada?.id});
    }
  });

  return tipoEntrada;
};

// Procesar datos para gráfico de ventas por día
export const ventasPorDia = (reportes) => {
  const ventasPorFecha = {};

  reportes.data.forEach((re) => {
    // Excluir entradas con status INVITADO
    if (re.status === 'INVITADO') {
      return;
    }

    const fecha = re.created_at.split('T')[0]; // Formato YYYY-MM-DD

    let precio = parseFloat(re.cantidad * re.unidad);
    if(re.descuento > 0){
      precio = precio - (precio/100*re.descuento);
    }

    if (!ventasPorFecha[fecha]) {
      ventasPorFecha[fecha] = {
        fecha: fecha,
        total: 0,
        cantidad: 0
      };
    }

    ventasPorFecha[fecha].total += precio;
    ventasPorFecha[fecha].cantidad += parseInt(re.cantidad);
  });

  // Convertir objeto a array y ordenar por fecha
  return Object.values(ventasPorFecha).sort((a, b) =>
    new Date(a.fecha) - new Date(b.fecha)
  );
};

// Procesar datos para gráfico de ventas por tipo de entrada
export const ventasPorTipoEntrada = (reportes) => {
  const ventasPorTipo = {};

  reportes.data.forEach((re) => {
    // Excluir entradas con status INVITADO
    if (re.status === 'INVITADO') {
      return;
    }

    const tipo = re.entrada?.nombre || 'Sin categoría';

    let precio = parseFloat(re.cantidad * re.unidad);
    if(re.descuento > 0){
      precio = precio - (precio/100*re.descuento);
    }

    if (!ventasPorTipo[tipo]) {
      ventasPorTipo[tipo] = {
        name: tipo,
        value: 0,
        cantidad: 0
      };
    }

    ventasPorTipo[tipo].value += precio;
    ventasPorTipo[tipo].cantidad += parseInt(re.cantidad);
  });

  return Object.values(ventasPorTipo);
};

// Procesar datos para gráfico de ventas por fecha de función
export const ventasPorFechaFuncion = (reportes) => {
  const ventasPorFecha = {};

  reportes.data.forEach((re) => {
    // Excluir entradas con status INVITADO
    if (re.status === 'INVITADO') {
      return;
    }

    const fecha = re.fecha; // Fecha de la función

    let precio = parseFloat(re.cantidad * re.unidad);
    if(re.descuento > 0){
      precio = precio - (precio/100*re.descuento);
    }

    if (!ventasPorFecha[fecha]) {
      ventasPorFecha[fecha] = {
        fecha: fecha,
        total: 0,
        cantidad: 0
      };
    }

    ventasPorFecha[fecha].total += precio;
    ventasPorFecha[fecha].cantidad += parseInt(re.cantidad);
  });

  return Object.values(ventasPorFecha);
};

// ==================== FUNCIONES DE PREDICCIÓN ====================

/**
 * Calcula la tasa de conversión de ventas (velocidad de venta)
 * @param {Object} reportes - Datos de reportes
 * @param {Object} evento - Datos del evento
 * @returns {Object} - Métricas de conversión
 */
export const calcularTasaConversion = (reportes, evento) => {
  if (!reportes?.data || !evento) return null;

  const fechaEvento = evento.fechas?.[0]?.fecha;
  const horaEvento = evento.fechas?.[0]?.hora;
  const stockTotal = evento.fechas?.[0]?.stock || 0;

  if (!fechaEvento) return null;

  // Calcular entradas vendidas (excluyendo invitados)
  const entradasVendidas = reportes.data.reduce((acc, re) => {
    if (re.status === 'INVITADO') return acc;
    return acc + parseInt(re.cantidad || 0);
  }, 0);

  // Calcular stock disponible
  const stockDisponible = stockTotal - entradasVendidas;
  const porcentajeVendido = (entradasVendidas / stockTotal) * 100;

  // Calcular días transcurridos desde la primera venta (excluyendo invitados)
  const ventas = reportes.data
    .filter(re => re.status !== 'INVITADO')
    .map(re => ({ fecha: new Date(re.created_at), cantidad: parseInt(re.cantidad) }))
    .sort((a, b) => a.fecha - b.fecha);

  const primeraVenta = ventas[0]?.fecha;
  const ultimaVenta = ventas[ventas.length - 1]?.fecha;
  const hoy = new Date();

  const diasDesdeInicio = primeraVenta
    ? Math.ceil((hoy - primeraVenta) / (1000 * 60 * 60 * 24))
    : 0;

  const diasHastaEvento = Math.ceil(
    (new Date(fechaEvento + 'T' + horaEvento) - hoy) / (1000 * 60 * 60 * 24)
  );

  // Tasa de ventas diaria promedio
  const ventasDiarias = diasDesdeInicio > 0 ? entradasVendidas / diasDesdeInicio : 0;

  return {
    entradasVendidas,
    stockTotal,
    stockDisponible,
    porcentajeVendido: parseFloat(porcentajeVendido.toFixed(2)),
    diasDesdeInicio,
    diasHastaEvento,
    ventasDiarias: parseFloat(ventasDiarias.toFixed(2)),
    primeraVenta,
    ultimaVenta
  };
};

/**
 * Predice las ventas futuras basándose en el comportamiento actual
 * @param {Object} reportes - Datos de reportes
 * @param {Object} evento - Datos del evento
 * @returns {Object} - Predicciones
 */
export const predecirVentas = (reportes, evento) => {
  const tasas = calcularTasaConversion(reportes, evento);
  if (!tasas) return null;

  const { stockDisponible, diasHastaEvento, ventasDiarias, stockTotal } = tasas;

  // Predicción lineal simple
  const ventasProyectadas = ventasDiarias * diasHastaEvento;
  const ventasTotalesProyectadas = tasas.entradasVendidas + ventasProyectadas;

  // Ajustar si excede el stock
  const ventasFinalesProyectadas = Math.min(ventasTotalesProyectadas, stockTotal);
  const porcentajeProyectado = (ventasFinalesProyectadas / stockTotal) * 100;

  // Fecha estimada de sold out
  let fechaSoldOut = null;
  let diasParaSoldOut = null;

  if (ventasDiarias > 0 && stockDisponible > 0) {
    diasParaSoldOut = Math.ceil(stockDisponible / ventasDiarias);
    fechaSoldOut = new Date();
    fechaSoldOut.setDate(fechaSoldOut.getDate() + diasParaSoldOut);
  }

  // Determinar estado de ventas
  let estadoVentas = 'normal';
  if (porcentajeProyectado >= 95) {
    estadoVentas = 'sold_out';
  } else if (porcentajeProyectado >= 70) {
    estadoVentas = 'alta_demanda';
  } else if (porcentajeProyectado < 50 && diasHastaEvento < 7) {
    estadoVentas = 'baja_demanda';
  }

  return {
    ventasProyectadas: Math.round(ventasProyectadas),
    ventasTotalesProyectadas: Math.round(ventasFinalesProyectadas),
    porcentajeProyectado: parseFloat(porcentajeProyectado.toFixed(2)),
    fechaSoldOut,
    diasParaSoldOut,
    estadoVentas,
    recomendacion: obtenerRecomendacion(estadoVentas, tasas, diasHastaEvento)
  };
};

/**
 * Obtiene recomendaciones basadas en el estado de ventas
 */
const obtenerRecomendacion = (estado, tasas, diasHastaEvento) => {
  switch (estado) {
    case 'sold_out':
      return 'Se espera agotamiento de entradas. Considere habilitar lista de espera o agregar funciones.';
    case 'alta_demanda':
      return 'Alta demanda detectada. Buen momento para intensificar la promoción.';
    case 'baja_demanda':
      if (diasHastaEvento < 7) {
        return 'Ventas por debajo del promedio. Considere activar descuentos o campañas de urgencia.';
      }
      return 'Ritmo de ventas bajo. Evalúe estrategias de marketing y promoción.';
    default:
      return 'Ventas dentro del rango esperado. Continúe monitoreando.';
  }
};

/**
 * Analiza el patrón de compra por hora del día
 * @param {Object} reportes - Datos de reportes
 * @returns {Array} - Distribución por horas
 */
export const analisisPorHora = (reportes) => {
  if (!reportes?.data) return [];

  const ventasPorHora = {};

  // Inicializar todas las horas
  for (let i = 0; i < 24; i++) {
    ventasPorHora[i] = { hora: `${i}:00`, cantidad: 0, transacciones: 0 };
  }

  reportes.data.forEach((re) => {
    // Excluir invitados
    if (re.status === 'INVITADO') return;

    const fecha = new Date(re.created_at);
    const hora = fecha.getHours();

    ventasPorHora[hora].cantidad += parseInt(re.cantidad || 0);
    ventasPorHora[hora].transacciones += 1;
  });

  return Object.values(ventasPorHora);
};

/**
 * Analiza patrones de compra (cantidad de entradas por transacción)
 * @param {Object} reportes - Datos de reportes
 * @returns {Object} - Análisis de patrones
 */
export const analizarPatronesCompra = (reportes) => {
  if (!reportes?.data || reportes.data.length === 0) return null;

  const cantidades = reportes.data
    .filter(re => re.status !== 'INVITADO')
    .map(re => parseInt(re.cantidad || 0));

  // Calcular estadísticas
  const total = cantidades.reduce((a, b) => a + b, 0);
  const promedio = total / cantidades.length;
  const moda = cantidades.sort((a, b) =>
    cantidades.filter(v => v === a).length - cantidades.filter(v => v === b).length
  ).pop();

  // Distribución por cantidad
  const distribucion = {};
  cantidades.forEach(cant => {
    distribucion[cant] = (distribucion[cant] || 0) + 1;
  });

  return {
    promedioEntradasPorCompra: parseFloat(promedio.toFixed(2)),
    cantidadMasFrecuente: moda,
    totalTransacciones: cantidades.length,
    distribucion: Object.entries(distribucion).map(([cantidad, frecuencia]) => ({
      cantidad: parseInt(cantidad),
      frecuencia,
      porcentaje: parseFloat(((frecuencia / cantidades.length) * 100).toFixed(2))
    })).sort((a, b) => b.frecuencia - a.frecuencia)
  };
};

/**
 * Calcula ingresos proyectados
 * @param {Object} reportes - Datos de reportes
 * @param {Object} prediccion - Datos de predicción
 * @returns {Object} - Proyección de ingresos
 */
export const proyectarIngresos = (reportes, prediccion) => {
  if (!reportes?.data || !prediccion) return null;

  // Calcular ingresos actuales (excluyendo invitados)
  const ingresosActuales = reportes.data.reduce((acc, re) => {
    if (re.status === 'INVITADO') return acc;
    let precio = parseFloat(re.cantidad * re.unidad);
    if (re.descuento > 0) {
      precio = precio - (precio / 100 * re.descuento);
    }
    return acc + precio;
  }, 0);

  // Calcular precio promedio por entrada (excluyendo invitados)
  const totalEntradas = reportes.data.reduce((acc, re) => {
    if (re.status === 'INVITADO') return acc;
    return acc + parseInt(re.cantidad || 0);
  }, 0);
  const precioPromedio = totalEntradas > 0 ? ingresosActuales / totalEntradas : 0;

  // Proyectar ingresos totales
  const ingresosProyectados = prediccion.ventasProyectadas * precioPromedio;
  const ingresosTotalesProyectados = ingresosActuales + ingresosProyectados;

  return {
    ingresosActuales: parseFloat(ingresosActuales.toFixed(2)),
    precioPromedio: parseFloat(precioPromedio.toFixed(2)),
    ingresosProyectados: parseFloat(ingresosProyectados.toFixed(2)),
    ingresosTotalesProyectados: parseFloat(ingresosTotalesProyectados.toFixed(2))
  };
};

/**
 * Cuenta el total de invitados
 * @param {Object} reportes - Datos de reportes
 * @returns {number} - Total de invitados
 */
export const totalInvitados = (reportes) => {
  if (!reportes?.data) return 0;

  let totalInvitados = 0;

  reportes.data.forEach((re) => {
    if (re.status === 'INVITADO') {
      let reporteCantidad = parseInt(re.cantidad);
      if (re.multiplicador) {
        reporteCantidad = reporteCantidad * re.multiplicador;
      }
      totalInvitados += reporteCantidad;
    }
  });

  return totalInvitados;
};
